import React, { useState, useEffect } from "react";
import { PublicParkingDataContext } from "./context";

import {
  getPublicParkingData,
  getPublicParkingDetails,
} from "../services/services";

const PublicParkingProvider = ({ children }) => {
  const [publicParkingData, setPublicParkingData] = useState(null);
  const [loadingPublicParking, setLoadingPublicParking] = useState(true);
  const [publicParkingDetailsData, setPublicParkingDetailsData] =
    useState(null);
  const [loadingPublicParkingDetails, setLoadingPublicParkingDetails] =
    useState(true);
  const [errorPublicParking, setErrorPublicParking] = useState(null);
  const [errorPublicParkingDetails, setErrorPublicParkingDetails] =
    useState(null);

  useEffect(() => {
    const fetchParking = async () => {
      const parking = await getPublicParkingData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoadingPublicParking(false);
            return response;
          } else {
            setLoadingPublicParking(false);
            return [];
          }
        })
        .catch((error) => {
          setLoadingPublicParking(false);
          setErrorPublicParking(error);
        });
      const parkingDetails = await getPublicParkingDetails({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoadingPublicParkingDetails(false);
            return response;
          } else {
            setLoadingPublicParkingDetails(false);
            return [];
          }
        })
        .catch((error) => {
          setLoadingPublicParkingDetails(false);
          setErrorPublicParkingDetails(error);
        });
      setPublicParkingData(parking);
      setPublicParkingDetailsData(parkingDetails);
    };

    fetchParking();
  }, []);

  return (
    <PublicParkingDataContext.Provider
      value={{
        publicParkingData,
        publicParkingDetailsData,
        setPublicParkingData,
        setPublicParkingDetailsData,
        loadingPublicParking,
        loadingPublicParkingDetails,
        errorPublicParking,
        errorPublicParkingDetails,
      }}
    >
      {children}
    </PublicParkingDataContext.Provider>
  );
};

export default PublicParkingProvider;
